// AreasPresentationSkeleton

/** MUI */
import { alpha, Card, CardHeader, CardContent, Skeleton } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Close, Search } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
    skeleton: {
        backgroundColor: alpha(theme.palette.primary.light, 0.25),
    },
    cardHeaderContent: {
        opacity: 1,
        display: "flex",
        alignItems: "center",
    },
}));

const SearchTreeSkeleton = () => {
    const classes = useStyles();
    return (
        <Card
            sx={{
                "&": (theme) => ({
                    ...theme.shape.boxedWrapper,
                    borderRadius: "6px",
                    p: 1,
                    width: "calc(100% - 0px)",
                    display: "flex",
                    alignItems: "center",
                }),
                height: 62,
                mt: 2,
                // ml: 2.5,
            }}
        >
            <CardHeader
                title={
                    <>
                        <Search sx={{ mr: 1.5, fontSize: "1.33333333rem", opacity: 0.5, color: "primary.main" }} />
                        <Skeleton height={8} className={classes.skeleton} variant="rectangular" sx={{ flexGrow: 1 }} />
                    </>
                }
                sx={{ py: 0.675, pl: 0.25, width: "100%" }}
                disableTypography
                classes={{ content: classes.cardHeaderContent }}
            />
        </Card>
    );
};

export default SearchTreeSkeleton;
